import { BaseConnector } from './baseConnector';

class KleMappingConnector extends BaseConnector {
  updateKleMappings(hearingTypeId, dtos) {
    var url = `${this.baseApiUrl}/hearingType/${hearingTypeId}/kleMappings`;
    return this.authPatch(url, dtos);
  }
}

export { KleMappingConnector };
